import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2025Certificado() {
  return <CategoryPage category="anexo30Y31Ano2025Certificado" pageTitle="Certificado JSON 2025" />;
}

export default Anexo30Y31Ano2025Certificado;
